import React, { useState } from "react";
import { Container, Card } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { useRef } from "react";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";


const Our_Location = (props) => {
  const sectionTitle = props.val.blc_different_locations_tag.split(" ");
  const [prevNav, setPrevNav] = useState(false);
  const [nextNav, setNextNav] = useState(true);
  const sliderRef = useRef(null);
  // replacing whitespace(%20) with (-) from loc name in url 
  function locNameFormatting(str) {
    if (str.indexOf(' ') >= 0) {
      return str.split(' ').join('-');
    }
    else {
      return str;
    }
  }

  // const settings = {
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 2.5,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   swipeToSlide: true,
  //   initialSlide: 0,

  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 2.5,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2.5,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 360,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // };
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 3.2,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
    afterChange: current => {
      if (current === 0) {
        setPrevNav(false);
        setNextNav(true);
      }
      else if (current === (props.val.blc_diff_locations.length - 3.2)) {
        setNextNav(false);
        setPrevNav(true);
      }
      else {
        setNextNav(true);
        setPrevNav(true);
      }
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <section id='different-locations'>
      <Container>
        <div className="slider-heading" style={{ width: '98%' }}>
          {/* <h2 className="titles text-start">{props.val.blc_different_locations_tag}</h2> */}
          <h2 className="titles">
            <span className='titles-black'>{sectionTitle[0]}</span>
            <span className='titles-black'> {sectionTitle[1]}</span>
            <span className="titles"> {sectionTitle[2]}</span>
          </h2>
          <div className="slider-nav-container">
            {
              prevNav && <div className="slider-navBtn" >
                <IoChevronBackOutline size={20} onClick={() => sliderRef.current.slickPrev()} />
              </div>
            }
            {
              nextNav && <div className="slider-navBtn" >
                <IoChevronForwardOutline size={20} onClick={() => sliderRef.current.slickNext()} />
              </div>
            }
          </div>
        </div>


        <div className="custom-padding-container row-full">
          <Slider ref={sliderRef} {...settings} className="blccard-card mb-5">
            {props.val.blc_diff_locations.map((location, idx) => (
              <Link to={`/locations/${locNameFormatting(location.location_name)}`}>
                <div key={Math.random()} className='pe-3'>
                  {/* <img
              key={idx}
              className="blccard"
              style={{
                backgroundImage: `url(${location.locations_img.data[0].attributes.formats.small.url})`,
              }}
            />
            <h6 className="py-3 loc-caption" style={{color: 'white' }}>{location.imgtext}</h6> */}
                  <Card className="card-bg slider-card">
                    <Card.Img className="blccard" src={location.locations_img.data[0].attributes.formats.small.url} alt="Card image" />
                    <Card.ImgOverlay style={{ paddingRight: '0px', paddingLeft: '0px' }}>
                      <p className="slider-card-title"><b>{location.location_name.toUpperCase()}</b></p>
                    </Card.ImgOverlay>
                  </Card>
                </div>
              </Link>
            ))}
          </Slider>
        </div>
      </Container>
    </section>


    //   <Container>
    //   <Container>
    //     <div className="justify-content-center">
    //       <h2 className="titles">{props.val.blc_different_locations_tag}</h2>
    //     </div>
    //   </Container>
    //   <Container className="py-5" style={{ flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
    //     <Slider ref={sliderRef} {...settings} className="blccard-card">
    //       {props.val.blc_diff_locations.map((location, idx) => (
    //         <Link to={`/locations/${locNameFormatting(location.location_name)}`}>
    //           <Container fluid key={Math.random()}>
    //             {/* <img
    //             key={idx}
    //             className="blccard"
    //             style={{
    //               backgroundImage: `url(${location.locations_img.data[0].attributes.formats.small.url})`,
    //             }}
    //           />
    //           <h6 className="py-3 loc-caption" style={{color: 'white' }}>{location.imgtext}</h6> */}
    //             <Card className="pricing-animation card-bg loc-card">
    //               <Card.Img className="blccard" src={location.locations_img.data[0].attributes.formats.small.url} alt="Card image" />
    //               <Card.ImgOverlay style={{ paddingRight: '0px', paddingLeft: '0px' }}>
    //                 <div className="bottom-caption">
    //                   <p className="text-center fix-center"><b>{location.location_name.toUpperCase()}</b></p>
    //                 </div>
    //               </Card.ImgOverlay>
    //             </Card>
    //           </Container>
    //         </Link>
    //       ))}
    //     </Slider>
    //   </Container>
    // </Container>
  );
};

export default Our_Location;
